import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const errorMessage = error.response.data?.message || 
                          error.response.data?.error || 
                          'An error occurred'
      
      const customError = new Error(errorMessage)
      customError.status = error.response.status
      customError.data = error.response.data
      
      return Promise.reject(customError)
    }
    
    return Promise.reject(new Error('Network error'))
  }
)

export const authService = {
  async register(userData) {
    const response = await api.post('/auth/register', userData)
    return response
  },

  async login(credentials) {
    const response = await api.post('/auth/login', credentials)
    return response
  },

  async getProfile() {
    const response = await api.get('/auth/profile')
    return response
  },

  async refreshToken() {
    const refreshToken = localStorage.getItem('refresh_token')
    const response = await api.post('/auth/refresh', {}, {
      headers: {
        Authorization: `Bearer ${refreshToken}`
      }
    })
    return response
  },

  async logout() {
    const response = await api.post('/auth/logout')
    return response
  }
}